import { render, staticRenderFns } from "./NewOtpValidate.vue?vue&type=template&id=7cc63778&scoped=true"
import script from "./NewOtpValidate.vue?vue&type=script&lang=js"
export * from "./NewOtpValidate.vue?vue&type=script&lang=js"
import style0 from "./NewOtpValidate.vue?vue&type=style&index=0&id=7cc63778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc63778",
  null
  
)

export default component.exports